import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

  load_TypesReport({commit, dispatch}) {
    return new Promise((resolve, reject) => {

      axios.get(Config.apiPath + 'type/report/list/all')
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  actions,
  mutations
};
